import type { TOC } from '@ember/component/template-only'
import { SideNavProductGroup } from 'teacher-ui-client/components/side-nav/product-group'
import { ReadingEggsReportsAccordion } from 'teacher-ui-client/components/side-nav/reading/reading-eggs-reports-accordion'

export const ReadingEggsProductGroup: TOC<unknown> = <template>
  <SideNavProductGroup @product="reading-eggs" class="bg-oceany-blue-50 rounded-lg">
    <ReadingEggsReportsAccordion />
  </SideNavProductGroup>
</template>

export default ReadingEggsProductGroup
